// extracted by mini-css-extract-plugin
module.exports = {"mediaSmBreakpoint":"768px","mediaMdBreakpoint":"992px","container":"TableCount_container__imhn3","count":"TableCount_count__2of0q"};